<template>
  <div>
    <loading-bar v-if="!!awaitingApiResponse" />
    <api-errors :errors="errors" />
    <v-row no-gutters>
      <v-text-field
        v-model="search"
        label="Search"
        hide-details
        clearable
        append-icon="mdi-magnify"
        class="px-3 py-2"
      />
    </v-row>
    <v-row
      no-gutters
      class="px-4"
    >
      <v-col cols="3">
        Covers
      </v-col>
      <v-col
        cols="6"
        md="3"
      >
        Reservee
      </v-col>
      <v-col
        v-if="$vuetify.breakpoint.mdAndUp"
        cols="3"
      >
        Details
      </v-col>
      <v-col
        cols="3"
        class="d-flex justify-end text-no-wrap"
      >
        Table #
      </v-col>
    </v-row>
    <v-card
      v-if="!(reservations || []).length"
      class="pa-2 ma-2 text-center font-weight-bold elevation-0"
    >
      No Reservations Found...
    </v-card>
    <div v-else>
      <reservation-card
        v-for="reservation in reservations"
        :key="'reservation-' + reservation.id"
        :reservation="reservation"
        :show-location="showAllReservations"
        class="ma-2"
        @click="$emit('select-reservation', reservation)"
      />
    </div>
  </div>
</template>

<script>
import ReservationCard from './ReservationCard'
import floorPlanHelpers from '../../mixins/floorPlanHelpers'
import moment from 'moment'
export default {
  name: 'ReservationsTab',
  components: {ReservationCard},
  mixins: [floorPlanHelpers],
  props: {
    location: {
      type: Object,
      default () {return {}}
    },
    mealPeriod: {
      type: Object,
      default () {return {}}
    },
    event: {
      type: Object,
      default () {return {}}
    },
    forEvent: Boolean,
    date: [String, Number],
    showAllReservations: Boolean,
  },
  data () {
    return {
      reservations: [],
      search: undefined,
      color: 'green',

      queryTimeout: undefined,
    }
  },
  watch: {
    location: {
      handler () {
        this.loadReservations()
      },
      deep: true
    },
    date () {
      this.loadReservations()
    },
    search () {
      if (this.queryTimeout) clearTimeout(this.queryTimeout)
      const _showAllReservations = this.showAllReservations
      this.queryTimeout = setTimeout(() => {
        if (_showAllReservations) this.loadAllReservations()
        else this.loadReservations()
      }, 400)
    },
    showAllReservations (newVal) {
      if (newVal) this.loadAllReservations()
      else this.loadReservations()
    }
  },
  mounted () {
    this.loadReservations()
  },
  methods: {
    loadAllReservations () {
      this.awaitingApiResponse = true
      this.$ftAPI().get(this.addResourceErrorHandler({
        command: 'diningReservation',
        load: this.reservations,
        loading: this.isLoading,
        afterLoad: () => this.awaitingApiResponse = false,
        error: (e) => {
          this.awaitingApiResponse = false
          this.errors.push(e.message)
        },
        params: {
          order_by: ['time:ASC'],
          children: true,
          include_fields: ['diningReservationDetail.member', 'locationName'],
          filter_methods: {
            filterByDate: [moment(this.date).format('YYYY-MM-DD')],
            filterHasMealPeriod: [],
            filterHasMemberByName: [this.search ?? ''],
            filterCancelled: [],
          }
        }
      }))
    },
    loadReservations () {
      if (!this.location.id) return

      let filter_methods = {
        filterByDate: [moment(this.date).format('YYYY-MM-DD')],
        filterHasMemberByName: [this.search ?? ''],
        filterCancelled: [],
      }
      if (this.mealPeriod.isCurrent) filter_methods.filterTimeAfterNow = []
      if (!this.forEvent) filter_methods.filterMealPeriod = [this.mealPeriod.id]

      this.awaitingApiResponse = true
      this.$ftAPI().get({
        command: 'diningReservation',
        load: this.reservations,
        loading: this.isLoading,
        afterLoad: () => this.awaitingApiResponse = false,
        error: (err) => {
          this.errors.push(err.message)
          this.awaitingApiResponse = false
        },
        params: {
          order_by: ['time:ASC'],
          children: true,
          include_fields: ['diningReservationDetail.member', 'hasOverbookedTable'],
          filter: this.forEvent
            ? [{field: 'eventId', operator: 'EQUAL', values: [this.event.id]}]
            : [{field: 'locationId', operator: 'EQUAL', values: [this.location.id]}],
          filter_methods
        }
      })
    }
  }
}
</script>
